const store = {
  state: {
    loading: false
  }
}
export default store
